/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PollReportQuestionMultipleNumericValue = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The PollReportQuestionMultipleNumericValue model module.
   * @module model/PollReportQuestionMultipleNumericValue
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>PollReportQuestionMultipleNumericValue</code>.
   * @alias module:model/PollReportQuestionMultipleNumericValue
   * @class
   */
  var exports = function() {
    var _this = this;











  };

  /**
   * Constructs a <code>PollReportQuestionMultipleNumericValue</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PollReportQuestionMultipleNumericValue} obj Optional instance to populate.
   * @return {module:model/PollReportQuestionMultipleNumericValue} The populated <code>PollReportQuestionMultipleNumericValue</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Title')) {
        obj['Title'] = ApiClient.convertToType(data['Title'], 'String');
      }
      if (data.hasOwnProperty('LastInputValue')) {
        obj['LastInputValue'] = ApiClient.convertToType(data['LastInputValue'], 'Number');
      }
      if (data.hasOwnProperty('DimensionTypeID')) {
        obj['DimensionTypeID'] = ApiClient.convertToType(data['DimensionTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('IsGroup')) {
        obj['IsGroup'] = ApiClient.convertToType(data['IsGroup'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('FatherID')) {
        obj['FatherID'] = ApiClient.convertToType(data['FatherID'], 'Integer');
      }
      if (data.hasOwnProperty('ScopeEndSort')) {
        obj['ScopeEndSort'] = ApiClient.convertToType(data['ScopeEndSort'], 'Integer');
      }
      if (data.hasOwnProperty('DepthLevel')) {
        obj['DepthLevel'] = ApiClient.convertToType(data['DepthLevel'], 'Integer');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Title
   * @default ''
   */
  exports.prototype['Title'] = '';
  /**
   * @member {Number} LastInputValue
   */
  exports.prototype['LastInputValue'] = undefined;
  /**
   * @member {Integer} DimensionTypeID
   * @default 0
   */
  exports.prototype['DimensionTypeID'] = 0;
  /**
   * @member {Integer} IsGroup
   * @default 0
   */
  exports.prototype['IsGroup'] = 0;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} FatherID
   */
  exports.prototype['FatherID'] = undefined;
  /**
   * @member {Integer} ScopeEndSort
   * @default 0
   */
  exports.prototype['ScopeEndSort'] = 0;
  /**
   * @member {Integer} DepthLevel
   * @default 0
   */
  exports.prototype['DepthLevel'] = 0;
  /**
   * @member {Integer} Sort
   * @default 0
   */
  exports.prototype['Sort'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


